import SelectAsyncProperty from "@/components/builder/properties/SelectAsync";
import { define } from "@/components/builder/utils";
import { useTemplateEngineContext } from "@/modules/cms/views/post/components/builder/compiler";

import { usePartialOptions } from "./LayoutRoot";

function PartialPreview({ path }) {
  return <>
    <SelectAsyncProperty
      name="path"
      useOptions={usePartialOptions}
    />
  </>
}

export function PartialHTML({ path }) {
  const { registerPartial } = useTemplateEngineContext()

  registerPartial(path)

  return <>
    {'<!-- line-break -->'}
    {`{{> ${path}}}`}
    {'<!-- line-break -->'}
  </>
}

export default define('partial', PartialPreview, PartialHTML)
  .tag({ children: false, attributes: 'props' })
  // .palete('--', 'Partial', 'Dynamic')
  .build()
